import { Environment as Env } from './prod.environment';
import { dev } from './data.environment';

export class Environment extends Env {
  static override readonly production: boolean = false;
  static override readonly urlAPI: string = 'https://adw-dev-am3.azurewebsites.net/';
  static override readonly urlAPIStable: string = 'https://adw-stable-dev.azurewebsites.net/';
  static override readonly urlAPIReward: string = 'https://adw-rewards-dev.azurewebsites.net/';
  // static override readonly urlAPI: string = 'https://aws-dev-wag-api.azurewebsites.net/';
  // static override readonly urlAPIStable: string = 'https://aws-dev-stable-api.azurewebsites.net/';
  // static override readonly urlAPIReward: string = 'https://aws-dev-reward-api.azurewebsites.net/';
  static override readonly enableAnalytics: boolean = false;
  static override readonly enableDevToolsRedux: boolean = true;
  static override readonly enableComponentView: boolean = true;
  static override readonly environment: string = 'development';
  static override readonly pusher = {
    key: dev?.pusher?.key,
    cluster: 'us2',
    beams: {
      instanceId: dev?.pusher?.beams?.instanceId,
      secretKey: ''
    }
  };
  static override readonly eProtect = {
    url: 'https://request.eprotect.vantivprelive.com/eProtect/js/eProtect-iframe-client3.min.js',
    jQuery: 'https://ajax.googleapis.com/ajax/libs/jquery/1.4.2/jquery.min.js',
    css: 'test',
    reportGroup: 'AmWagerPro'
  };
  static override readonly smartlook: string = '';
  static override readonly truliooMobileLink:
    string = 'https://launch-workflow.trulioo.com/test/686fc5cdc5f8f14a1eb6d63c?x-hf-session=';
  static override readonly truliooWebLink:
    string = 'https://launch-workflow.trulioo.com/test/67c9d42304b3837ecab2c28c?x-hf-session=';
}
